import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'form'];

  formatInputs () {
    if (!this.formTarget.checkValidity()) { return; }

    this.inputTargets.forEach((el) => {
      if (el.value) {
        el.value = el.value * 1000000;
      }
    });
  }

  unformatInputs () {
    this.inputTargets.forEach((el) => {
      if (el.value) {
        el.value = el.value / 1000000;
      }
    });
  }
}
